import { LocalTournament } from 'react-easyrocket';

import { create } from 'zustand';

interface BonusModalState {
  idBonusModal: number | null;
  setModal: (state: number | null) => void;
}

interface NotificationTournamentStore {
  newTournament: LocalTournament | null;
  setNewTournament: (state: LocalTournament | null) => void;
}

export const useBonusModalStore = create<BonusModalState>((set) => ({
  idBonusModal: null,
  setModal: (state) => set({ idBonusModal: state })
}));

const currentFavoriteMap = new Map<number, boolean>();
const listenersMap = new Map<number, Set<() => void>>();

export const linkFavoritesStore = (gameId: number, initialValue: boolean) => {
  if (!currentFavoriteMap.has(gameId)) {
    currentFavoriteMap.set(gameId, initialValue);
    listenersMap.set(gameId, new Set());
  }

  const getSnapshot = () => currentFavoriteMap.get(gameId);

  const subscribe = (callback: () => void) => {
    const listeners = listenersMap.get(gameId);
    listeners?.add(callback);
    return () => listeners?.delete(callback);
  };

  const updateSnapshot = (newValue: boolean) => {
    currentFavoriteMap.set(gameId, newValue);
    listenersMap.get(gameId)?.forEach((callback) => callback());
  };

  return { getSnapshot, subscribe, updateSnapshot };
};

export const useNotifiacationLocalTournamentStore = create<NotificationTournamentStore>((set) => ({
  newTournament: null,
  setNewTournament: (state) => set({ newTournament: state })
}));
